<template>
  <div
    :style="{
      ...coordinatedStyles,
    }"
    class="position-block-wrapper"
  >
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
.position-block-wrapper {
  display: block;
  position: absolute;

  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  & > ::v-deep(*) {
    transform: var(--computed-transform);
    inset: var(--computed-inset);
    // max-width: var(--coumputed-max-width);
    // max-height: var(--coumputed-max-height);

    display: block;
    position: relative;
  }

  & > ::v-deep(img) {
    display: block;
    visibility: visible;
    width: 100%;
    height: auto;
    max-width: unset;
    max-height: unset;
  }
}
</style>

<script>
export default {
  props: {
    x: {
      type: Number,
      require: false,
      default: 0,
    },

    y: {
      type: Number,
      require: false,
      default: 0,
    },

    scale: {
      type: Number,
      require: false,
      default: 1,
    },

    rotate: {
      type: Number,
      require: false,
      default: 0,
    },
  },

  data() {
    return {};
  },

  computed: {
    coordinatedStyles() {
      const styleVars = {
        "--computed-inset": `${this.y}% ${-this.x}% ${-this.y}% ${this.x}%`,
        "--computed-transform": `scale(${this.scale}) rotate(${this.rotate}deg)`,
        // "--coumputed-max-width": "unset",
        // "--coumputed-max-height": "unset",
      };

      return styleVars;
    },
  },
};
</script>
